import { Navbar, Page } from "framework7-react";

import { ChangePasswordForm } from "@/components/ChangePasswordForm";
import { NavLeftBack } from "@/components/NavLeftBack";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { useBack } from "@/hooks/useBack";
import { usePageReady } from "@/hooks/usePageReady";

export const ChangePasswordPage = createPage("ChangePasswordPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const back = useBack();
  const { getPageProps } = usePageReady(pageName);

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftBack />
        <NavTitle>パスワード変更</NavTitle>
        <NavRightEmpty />
      </Navbar>
      <ChangePasswordForm onCompleted={back} />
    </Page>
  );
}
